<template>
    <div style="width: 290px;">
        <label for="tariffValue-list" class="vs-input--label truncate">Лицевые счета</label>
        <v-select :options="apartments"
                  label="account_number"
                  v-model="listLocal"
                  class="app-v-select app-v-select_multiple invoice-generate-text-select"
                  :reduce="option => option.account_number"
                  :key="`select`"
                  :multiple="true"
                  maxHeight="200px"
                  :appendToBody="true"
                  :disabled="disabled"
        >
            <template slot="selected-option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                    {{ option.account_number }}
                </div>
            </template>
            <template slot="option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                    {{ option.account_number }}
                </div>
            </template>
            <template slot="no-options">
                Лицевые счета не найдены
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        name: "TariffExtraConditionsListInput",
        props: {
            list: {
                required: true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            apartments: {}
        },
        data(){
            return {
                isInput: true,
            }
        },
        computed: {
            listLocal: {
                get(){
                    return this.list !== null ? this.list.split(',') : [];
                },
                set(value){
                    this.$emit('change', value.join(','));
                }
            }
        },
        watch: {
            isInput(){
                if(!this.isInput){
                    this.$nextTick(() => {
                        this.$refs.tariffValueListTextArea.$el.querySelector('textarea').focus();
                    })
                }
                this.$emit('update');
            }
        }
    }
</script>

<style lang="scss">
.vs__dropdown-menu{
    z-index: 99999;
}
</style>